import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Observable, Subscription, filter } from 'rxjs';
import { RBE24230_DEFAULT_OUTPUTS_STATUS } from 'src/app/conf/rbe24230';
import { RBE4_OUTPUT_MASKS } from 'src/app/conf/rbe4';
import { Device } from 'src/app/model/device';
import { DeviceStatus } from 'src/app/model/device-status';

import { AppState } from 'src/app/store/app.reducer';
import * as DeviceActions from 'src/app/store/device/device.actions';
import { AutomationsAliasDialogComponent } from '../automations-alias-dialog/automations-alias-dialog.component';
import { AutomationsAlias, InputsAlias } from 'src/app/model/automations-alias';
import { selectAutomationAlias, selectCurrentDevice, selectCurrentDeviceStatus } from 'src/app/store/device/device.selector';


@Component({
    selector: 'app-inputs',
    templateUrl: './inputs.component.html',
    providers: [],
    styles: `
		:host ::ng-deep .p-panel-header {
			border: 1px solid #D5D5D5 !important;
			border-bottom: none !important;
		}
		:host ::ng-deep .p-panel-content {
			border: 1px solid #D5D5D5 !important;
		}
	`
})
export class InputsComponent implements OnInit, OnDestroy {
    automationsAlias$: Observable<AutomationsAlias | undefined>;
    automationsAliasSub: Subscription | undefined;

    device: Device = new Device();
    stateSub: Subscription;
    deviceSub: Subscription;
    deviceStatus: DeviceStatus;
    deviceConfigured: boolean;

    InputsAlias: InputsAlias[];
    inputArray: boolean[] = [];

    ref: DynamicDialogRef | undefined;

    TYPE_ALIAS_INPUT = "TYPE_ALIAS_INPUT";
    constructor(
        private store: Store<AppState>,
        private translate: TranslateService,
        public dialogService: DialogService,
    ) {
        this.initSelectors();
    }

    initSelectors(): void {
        this.automationsAlias$ = this.store.select(selectAutomationAlias);
    }

    ngOnInit(): void {
        this.stateSub = this.store.select(selectCurrentDeviceStatus).pipe(filter(ds => !!ds)).subscribe(deviceStatus => {
            this.deviceStatus = deviceStatus;
            this.deviceConfigured = deviceStatus.Configured === 0;
            if (this.device !== undefined && this.device.ModelId !== undefined) {
                this.inputRbe();
            }
        });
        this.deviceSub = this.store.select(selectCurrentDevice)
            .pipe(filter(dm => !!dm))
            .subscribe(device => {
                this.device = device;
                if (this.deviceStatus !== undefined && this.deviceStatus.States !== undefined) {
                    this.inputRbe();
                }
            });
        this.automationsAliasSub = this.automationsAlias$.subscribe(automationsAlias => {
            if (automationsAlias !== undefined && automationsAlias.Inputs !== undefined) {
                this.InputsAlias = automationsAlias.Inputs;
            }
        });
    }

    inputRbe(): void {
        this.inputArray = RBE24230_DEFAULT_OUTPUTS_STATUS;
        if (this.device !== undefined && this.device.ModelId !== undefined &&
            this.deviceStatus !== undefined && this.deviceStatus.States !== undefined) {
            const os = this.deviceStatus.InputsStatus;
            if (os) {
                //consider only first byte
                this.inputArray = this.splitData(os[2]);
            } else {
                this.inputArray = RBE24230_DEFAULT_OUTPUTS_STATUS;
            }
        }
    }

    ngOnDestroy(): void {
        this.stateSub?.unsubscribe();
        this.deviceSub?.unsubscribe();
        this.automationsAliasSub?.unsubscribe();
    }

    splitData(oByte: number): boolean[] {
        const arr: boolean[] = [];
        for (const mask of RBE4_OUTPUT_MASKS) {
            // eslint-disable-next-line no-bitwise
            arr.push((oByte & mask) !== 0);
        }
        return arr;
    }

    editAlias(): void {
        this.store.dispatch(DeviceActions.resetEditAutomationsAlias());
        this.ref = this.dialogService.open(AutomationsAliasDialogComponent, {
            header: this.translate.instant('INPUT_ALIAS'),
            width: '70vw',
            breakpoints: { '1250px': '98vw' },
            contentStyle: { overflow: 'auto' },
            data: {
                typeAlias: this.TYPE_ALIAS_INPUT
            }
        });
    }

    translateDataAlias(id: number): string {
        let resStr = '';
        if (this.InputsAlias !== undefined) {
            for (const input of this.InputsAlias) {
                if (input.Id === id) {
                    resStr = this.translateData(input.Description);
                }
            }
        }
        return resStr;
    }


    translateData(str: string): string {
        let resStr = '';
        const fields = str.split('{');
        for (const field of fields) {
            if (field.indexOf('}') >= 0) {
                const toTranslate = field.split('}');
                resStr = resStr + this.translate.instant(toTranslate[0]) + toTranslate[1];
            } else {
                resStr = resStr + field;
            }
        }
        return resStr;
    }
}
